<template lang="pug">
.view-toggle
	fieldset.view-toggle__inner
		legend.view-toggle__legend Choose the view for results
		label.view-toggle__label(for="grid-view", title="View results in a grid") 
			span View results in a grid
			input#grid-view.view-toggle__radio(
				type="radio",
				name="search-app-view",
				value="grid",
				v-model="view"
			)
			.view-toggle__display.view-toggle__display--grid
		label.view-toggle__label(for="list-view", title="View results in a list") 
			span View results in a list
			input#list-view.view-toggle__radio(
				type="radio", 
				name="search-app-view",
				value="list",
				v-model="view"
			)
			.view-toggle__display.view-toggle__display--list
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
	name: "ResultViewToggle",
	props: {},
	computed: {
		...mapGetters(["resultView"]),
		view: {
			get() {
				return this.resultView;
			},
			set(val) {
				this.setStateValue(["resultView", val])
			}
		},
	},
	methods: {
		...mapMutations(["setStateValue"]),
	},
	// created() {},
}
</script>

<style lang="scss" scoped>
.view-toggle {
	@include mqdn(sm_dn) {
		display: none;
	}
	&__inner {
		display: flex;
		border-radius: 0.5rem;
		padding: 0;
		border: none;
		&:focus-within {
			border: solid 1px var(--focus-color);
			box-shadow: 0 0 0 1px var(--focus-color);
		}
	}
	&__legend {
		@include hideVisually;
	}
	&__label {
		span {
			@include hideVisually;
		}
	}
	&__radio {
		position: absolute;
		height: 1px;
		width: 1px;
		opacity: 0;
	}
	&__display {
		display: flex;
		padding: 0.625rem;
		font-size: 1.125rem;
		background: $lightGray;
		border: solid 1px $midGray;
		cursor: pointer;
		input[type=radio]:checked + & {
			color: $white;
			box-shadow: -0.0625rem -0.0625rem 0.125rem $white inset;
			cursor: default;
			.page--ORG & {
				background: $blue;
			}
			.page--TSP & {
				background: $blueTsp;
			}
			.page--TXC & {
				background: $primary700txc;
			}
			.page--BOB & {
				background: $primary800bob;
			}
			.page--BUY & {
				background: $primary700buy;
			}
		}
		&--grid {
			border-radius: 0.5rem 0 0 0.5rem;
			&::before {
				@include icon;
				content: "\e984";
			}
		}
		&--list {
			border-radius: 0 0.5rem 0.5rem 0;
			&::before {
				@include icon;
				content: "\e983";
			}
		}
	}
}
</style>